export default {
	apiKey: "AIzaSyBzjkai1hUrt8NSKMiQza7d6-aPwTCOQT8",
    authDomain: "clearnumbershosting.firebaseapp.com",
    databaseURL: "https://clearnumbershosting.firebaseio.com",
    projectId: "clearnumbershosting",
    storageBucket: "clearnumbershosting.appspot.com",
    messagingSenderId: "60809852467"
}
